import { type Booking, type BookingClient, EmailTemplatePurpose, type Location, type SchedulingEventType } from '../../../models/Scheduling'
import { type User } from '../../../models/User'
import { buildEmailTemplateContext, type EmailTemplateContextInput } from '../flows/buildEmailTemplateContext'
import { unsubscribeLink } from '../flows/clientInviteLinks'

export interface FollowUpPreviewInput {
  booking: Booking
  client: BookingClient
  eventType: SchedulingEventType
  owner?: User
  account?: EmailTemplateContextInput['account']
  location?: Location
}

export const followUpPreviewValues = ({ booking, client, eventType, owner, account, location }: FollowUpPreviewInput): Record<string, string> => {
  const context = buildEmailTemplateContext({
    eventType,
    client,
    owner,
    meetingMode: booking.meetingMode,
    location,
    bookingLink: client.inviteUrl,
    unsubscribeLink: unsubscribeLink(client, EmailTemplatePurpose.REMINDER_TO_BOOK),
    account,
  })
  return Object.fromEntries(Object.entries(context).filter(([, value]) => value !== ''))
}
